
import {serviceApprovalCheckedConstants} from './constants.js';
export default function serviceApprovalCheckedReducer(state={
    myServicesApproval: {},
    othersServicesApproval: {},
    fetched: false,
    loadingSearch:false,
    loading:false,
    saved:false,
  }, action) {

    state = {...state,saved:{...state.saved ,serviceStart:false},loading:{...state.loading ,getService:false }}
    switch (action.type) {



        // My 
        case serviceApprovalCheckedConstants.GET_ALL_MY_SERVICE_APPROVAL_CHECKED_PENDING: {
            return {...state,loading:{...state.loading ,getService:false }, user: action.payload,saved:false}
        }  
        case  serviceApprovalCheckedConstants.GET_ALL_MY_SERVICE_APPROVAL_CHECKED_FULFILLED: {
            return {...state,loading:{...state.loading ,getService:false }, myServicesApproval:action?.payload?.data?.data}
        }    
        case serviceApprovalCheckedConstants.GET_ALL_MY_SERVICE_APPROVAL_CHECKED_FAILURE:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.error}
        }
        case serviceApprovalCheckedConstants.GET_ALL_MY_SERVICE_APPROVAL_CHECKED_REJECTED:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.payload}
        }


         // Others
        case serviceApprovalCheckedConstants.GET_ALL_OTHERS_SERVICE_APPROVAL_CHECKED_PENDING: {
            return {...state,loading:{...state.loading ,getService:false }, user: action.payload,saved:false}
        }  
        case  serviceApprovalCheckedConstants.GET_ALL_OTHERS_SERVICE_APPROVAL_CHECKED_FULFILLED: {
            return {...state,loading:{...state.loading ,getService:false }, othersServicesApproval:action?.payload?.data?.data}
        }    
        case serviceApprovalCheckedConstants.GET_ALL_OTHERS_SERVICE_APPROVAL_CHECKED_FAILURE:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.error}
        }
        case serviceApprovalCheckedConstants.GET_ALL_OTHERS_SERVICE_APPROVAL_CHECKED_REJECTED:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.payload}
        }


        case serviceApprovalCheckedConstants.SAVE_SERVICE_APPROVAL_CHECKED_PENDING: {
            return {...state,loading:{...state.loading , saveServiceReport:true },save:{...state.save , saveServiceReport:false } ,}
        }  
        case  serviceApprovalCheckedConstants.SAVE_SERVICE_APPROVAL_CHECKED_FULFILLED: {
            return {...state,loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:true } , serviceReport:action?.payload?.data?.data}
        }    
        case serviceApprovalCheckedConstants.SAVE_SERVICE_APPROVAL_CHECKED_FAILURE:  {
            return {...state, loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:false } ,error:action.error}
        }
        case serviceApprovalCheckedConstants.SAVE_SERVICE_APPROVAL_CHECKED_REJECTED:  {
            return {...state, loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:false } ,error:action.payload}
        }

        case serviceApprovalCheckedConstants.SAVE_FALSE :  {
            return {...state,save:{...state.save , 
                    
                     saveServiceReport:false } 
                      ,error:{}}
        }
       
        default :
            return state;
    }

}
